import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment.dev";
import { BaseService } from "../../@core/services/base.service";
import { IComment, IUser } from "../../@core/models/model";
import { COMMENTS_TYPE } from "../../@core/models/enums";

@Injectable({ providedIn: 'root' })
export class CommentsService extends BaseService {

    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    apiUrl = environment.apiUrl + '/user-comments';

    getComments(itemId: string) {
        return this.get<IComment[]>(`${this.apiUrl}/${itemId}`)
    }

    addOrUpdateComment(commentData: Partial<IComment>) {
        return this.post<IComment>(this.apiUrl, commentData)
    }

    deleteComment(commentId: string) {
        return this.delete(`${this.apiUrl}/${commentId}`)
    }

    checkPermissions(contract: string, mentions: string[], commentsType: COMMENTS_TYPE) {
        return this.post<Partial<IUser[]>>(`${this.apiUrl}/check-permissions`, { contract, mentions, commentsType })
    }
}
